
import { Component, Vue, Prop } from "vue-property-decorator";
import { TreeNode } from "@/types/tree";
import { ElementPositionOnCanvas } from "@/futurelayer/canvas/canvas-controls/element-positioning";
import { singularityStore } from "@/store/store";
import { hasFutureLayerPreferOverlayHeaderClass, isFirstChildInRootAfterHeader } from "@/futurelayer/headers-footers/overlay-headers";

@Component
export default class AddAnotherSectionButton extends Vue {
  @Prop()
  element!: TreeNode;

  @Prop()
  elementPositionOnCanvas!: ElementPositionOnCanvas;

  mouseY = 0;

  mounted() {
    window.Breakdance.canvas.document.addEventListener(
      "mousemove",
      this.handleMouseMove
    );
  }

  beforeDestroy() {
    window.Breakdance.canvas.document.removeEventListener(
      "mousemove",
      this.handleMouseMove
    );
  }

  handleMouseMove(event: MouseEvent) {
    this.mouseY = event.clientY;
  }

  isMouseNearButton(buttonY: number): boolean {
    const PROXIMITY_THRESHOLD = 50;
    return Math.abs(this.mouseY - buttonY) <= PROXIMITY_THRESHOLD;
  }

  get isFirstChildInRootAfterHeaderAndHasFutureLayerPreferOverlayHeaderClass() {
    return isFirstChildInRootAfterHeader(this.element.id) && hasFutureLayerPreferOverlayHeaderClass(this.element);
  }

  get cssStyleForAddSectionTop(): Record<string, string> {
    if (!this.elementPositionOnCanvas) {
      return { display: "none" };
    }

    // Convert absolute position to viewport position
    const elementTopAbsolute = parseFloat(
      this.elementPositionOnCanvas.top.replace("px", "")
    );
    const scrollTop =
      window.Breakdance.canvas.document.documentElement.scrollTop;
    const buttonY = elementTopAbsolute - scrollTop;

    if (!this.isMouseNearButton(buttonY)) {
      return { display: "none" };
    }

    return {
      left: `calc(${this.elementPositionOnCanvas.width} * 0.5)`,
      top: "0px",
      transform: "translate(-50%, -50%)"
    };
  }

  get cssStyleForAddSectionBottom(): Record<string, string> {
    if (!this.elementPositionOnCanvas) {
      return { display: "none" };
    }

    const elementTopAbsolute = parseFloat(
      this.elementPositionOnCanvas.top.replace("px", "")
    );
    const elementHeight = parseFloat(
      this.elementPositionOnCanvas.height.replace("px", "")
    );
    const scrollTop =
      window.Breakdance.canvas.document.documentElement.scrollTop;
    const buttonY = elementTopAbsolute + elementHeight - scrollTop;

    if (!this.isMouseNearButton(buttonY)) {
      return { display: "none" };
    }

    return {
      left: `calc(${this.elementPositionOnCanvas.width} * 0.5)`,
      top: this.elementPositionOnCanvas.height,
      transform: "translate(-50%, -50%)"
    };
  }

  handleAddSectionBefore() {
    singularityStore.setSectionAddOrSwapPanelState({
      mode: "add_before",
      sectionId: this.element.id
    });
    singularityStore.setSectionLibraryModalState(true);
  }

  handleAddSectionAfter() {
    singularityStore.setSectionAddOrSwapPanelState({
      mode: "add_after",
      sectionId: this.element.id
    });
    singularityStore.setSectionLibraryModalState(true);
  }
}
